import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Card,
  CardBody,
  Copy,
  Bold,
  Row,
  Spin,
  Title,
  Button,
  Icon
} from "app/NativeComponents/common";
import EventCalendar from "app/NativeComponents/components/EventCalendar";
import { InformationItem, PillButton } from "app/NativeComponents/snippets";

import EventListTab from "./EventListTab";
import MailerList from "./MailerList";
import PropertyList from "./PropertyList";

import {
  appRedirect,
  getCalendar,
  getMailers,
  getActivityProperties,
  renderPrice,
  selectActiveProperty
} from "app/NativeActions";

import moment from "moment";

class CalendarTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      start_date: moment().startOf("month").format("YYYY-MM-DD"),
      end_date: moment().endOf("month").format("YYYY-MM-DD"),

      selected_date: null,

      is_selecting_range: false,
      range_selected_dates: [],

      total_mailers_in_queue: 0,
      total_mailers_to_send: 0,
      total_mailers_sent: 0,
      total_dealcredit_to_spend: 0,

      event_list_tab: "mailers_sent"
    };

    this.getItems = this.getItems.bind(this);
  }

  componentDidMount() {
    this.getCalendarEvents(
      this.state.start_date,
      this.state.end_date,
      "refresh"
    );

    this.getItems({
      type: this.state.event_list_tab,
      load_type: "refresh",
      begin: 0
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.start_date !== this.state.start_date ||
      prevState.end_date !== this.state.end_date
    ) {
      this.getCalendarEvents(this.state.start_date, this.state.end_date);
    }

    if (
      (prevProps.calendar_events.length == 0 &&
        prevProps.calendar_events !== this.props.calendar_events) ||
      prevState.range_selected_dates !== this.state.range_selected_dates ||
      prevState.is_selecting_range !== this.state.is_selecting_range ||
      prevState.start_date !== this.state.start_date ||
      prevState.end_date !== this.state.end_date
    ) {
      this.generateAmounts();
    }
  }

  getItems({ type, load_type = "load", begin = 0 }) {
    const {
      is_selecting_range,
      range_selected_dates,
      selected_date,
      start_date,
      end_date
    } = this.state;

    switch (type) {
      case "mailers_sent":
        if (
          (is_selecting_range && range_selected_dates.length == 0) ||
          (!is_selecting_range && selected_date == null)
        ) {
          this.props.getMailers({
            token: this.props.token,
            min_date_mailed: moment(start_date).format("YYYY-MM-DD"),
            max_date_mailed: moment(end_date).format("YYYY-MM-DD"),
            begin,
            load_type
          });
        } else {
          if (is_selecting_range && range_selected_dates.length == 2) {
            this.props.getMailers({
              token: this.props.token,
              min_date_mailed: moment(range_selected_dates[0]).format(
                "YYYY-MM-DD"
              ),
              max_date_mailed: moment(range_selected_dates[1]).format(
                "YYYY-MM-DD"
              ),
              begin,
              load_type
            });
          } else if (!is_selecting_range && selected_date) {
            this.props.getMailers({
              token: this.props.token,
              min_date_mailed: moment(selected_date).format("YYYY-MM-DD"),
              max_date_mailed: moment(selected_date).format("YYYY-MM-DD"),
              begin,
              load_type
            });
          }
        }
        break;

      case "mailers_queued":
        const queued_filters = {
          sending_queue: "in_sending_queue"
        };
        this.props.getActivityProperties({
          token: this.props.token,
          filters: queued_filters,
          begin,
          load_type
        });
        break;

      case "mailers_to_send":
        let to_send_filters = {};

        if (
          (is_selecting_range && range_selected_dates.length == 0) ||
          (!is_selecting_range && selected_date == null)
        ) {
          to_send_filters = {
            scheduled_to_send_min: moment(start_date).format("YYYY-MM-DD"),
            scheduled_to_send_max: moment(end_date).format("YYYY-MM-DD")
          };
          this.props.getActivityProperties({
            token: this.props.token,
            filters: to_send_filters,
            begin,
            load_type
          });
        } else {
          if (is_selecting_range && range_selected_dates.length == 2) {
            to_send_filters = {
              scheduled_to_send_min: moment(range_selected_dates[0]).format(
                "YYYY-MM-DD"
              ),
              scheduled_to_send_max: moment(range_selected_dates[1]).format(
                "YYYY-MM-DD"
              )
            };
            this.props.getActivityProperties({
              token: this.props.token,
              filters: to_send_filters,
              begin,
              load_type
            });
          } else if (!is_selecting_range && selected_date) {
            to_send_filters = {
              scheduled_to_send_min: moment(selected_date).format("YYYY-MM-DD"),
              scheduled_to_send_max: moment(selected_date).format("YYYY-MM-DD")
            };

            this.props.getActivityProperties({
              token: this.props.token,
              filters: to_send_filters,
              begin,
              load_type
            });
          }
        }

        break;
      default:
        break;
    }
  }

  getCalendarEvents(start_date, end_date, type = "load") {
    this.props.getCalendar({
      token: this.props.token,
      start_date,
      end_date,
      type
    });
  }

  onDateChange(selected_item) {
    if (this.state.is_selecting_range == true) {
      this.setState({
        selected_date: null,
        range_selected_dates: selected_item.map(date => {
          return moment(date).format("YYYY-MM-DD");
        })
      });
    } else {
      this.setState({
        selected_date: selected_item
          ? moment(selected_item).format("YYYY-MM-DD")
          : null,
        range_selected_dates: []
      });
    }

    this.generateAmounts();
  }

  onMonthChange(active_start_date) {
    this.setState({
      start_date: moment(active_start_date)
        .startOf("month")
        .format("YYYY-MM-DD"),
      end_date: moment(active_start_date).endOf("month").format("YYYY-MM-DD"),
      selected_date: null,
      range_selected_dates: []
    });
  }

  generateAmounts() {
    let total_mailers_in_queue = 0;
    let total_mailers_to_send = 0;
    let total_mailers_sent = 0;
    let total_dealcredit_to_spend = 0;

    const {
      is_selecting_range,
      range_selected_dates,
      selected_date,
      start_date,
      end_date
    } = this.state;
    const { calendar_events } = this.props;
    if (
      (is_selecting_range && range_selected_dates.length == 0) ||
      (!is_selecting_range && selected_date == null)
    ) {
      for (
        let m = moment(start_date);
        m.isBefore(moment(end_date).add(1, "days"));
        m.add(1, "days")
      ) {
        for (let i = 0; i < calendar_events.length; i++) {
          if (
            calendar_events[i].calendar_date == moment(m).format("YYYY-MM-DD")
          ) {
            total_mailers_in_queue =
              total_mailers_in_queue +
              calendar_events[i].total_mailers_in_queue;
            total_mailers_to_send =
              total_mailers_to_send + calendar_events[i].total_mailers_to_send;
            total_mailers_sent =
              total_mailers_sent + calendar_events[i].total_mailers_sent;
            total_dealcredit_to_spend =
              total_dealcredit_to_spend +
              calendar_events[i].total_dealcredit_to_spend;
          }
        }
      }

      if (total_mailers_sent > 0) {
        this.updateEventListTab("mailers_sent");
      } else if (total_mailers_in_queue > 0) {
        this.updateEventListTab("mailers_queued");
      } else if (total_mailers_to_send > 0) {
        this.updateEventListTab("mailers_to_send");
      }

      this.setState({
        total_mailers_in_queue: total_mailers_in_queue,
        total_mailers_to_send: total_mailers_to_send,
        total_mailers_sent: total_mailers_sent,
        total_dealcredit_to_spend: total_dealcredit_to_spend
      });
    } else {
      if (is_selecting_range && range_selected_dates.length == 2) {
        let total_mailers_in_queue = 0;
        let total_mailers_to_send = 0;
        let total_mailers_sent = 0;
        let total_dealcredit_to_spend = 0;

        for (
          let m = moment(range_selected_dates[0]);
          m.isBefore(moment(range_selected_dates[1]).add(1, "days"));
          m.add(1, "days")
        ) {
          for (let i = 0; i < calendar_events.length; i++) {
            if (
              calendar_events[i].calendar_date == moment(m).format("YYYY-MM-DD")
            ) {
              total_mailers_in_queue =
                total_mailers_in_queue +
                calendar_events[i].total_mailers_in_queue;
              total_mailers_to_send =
                total_mailers_to_send +
                calendar_events[i].total_mailers_to_send;
              total_mailers_sent =
                total_mailers_sent + calendar_events[i].total_mailers_sent;
              total_dealcredit_to_spend =
                total_dealcredit_to_spend +
                calendar_events[i].total_dealcredit_to_spend;
            }
          }
        }
        if (total_mailers_sent > 0) {
          this.updateEventListTab("mailers_sent");
        } else if (total_mailers_in_queue > 0) {
          this.updateEventListTab("mailers_queued");
        } else if (total_mailers_to_send > 0) {
          this.updateEventListTab("mailers_to_send");
        }

        this.setState({
          total_mailers_in_queue: total_mailers_in_queue,
          total_mailers_to_send: total_mailers_to_send,
          total_mailers_sent: total_mailers_sent,
          total_dealcredit_to_spend: total_dealcredit_to_spend
        });
      } else if (!is_selecting_range) {
        for (let i = 0; i < calendar_events.length; i++) {
          if (
            calendar_events[i].calendar_date ==
            moment(selected_date).format("YYYY-MM-DD")
          ) {
            total_mailers_in_queue = calendar_events[i].total_mailers_in_queue;
            total_mailers_to_send = calendar_events[i].total_mailers_to_send;
            total_mailers_sent = calendar_events[i].total_mailers_sent;
            total_dealcredit_to_spend =
              calendar_events[i].total_dealcredit_to_spend;
          }
        }

        if (total_mailers_sent > 0) {
          this.updateEventListTab("mailers_sent");
        } else if (total_mailers_in_queue > 0) {
          this.updateEventListTab("mailers_queued");
        } else if (total_mailers_to_send > 0) {
          this.updateEventListTab("mailers_to_send");
        }

        this.setState({
          total_mailers_in_queue: total_mailers_in_queue,
          total_mailers_to_send: total_mailers_to_send,
          total_mailers_sent: total_mailers_sent,
          total_dealcredit_to_spend: total_dealcredit_to_spend
        });
      }
    }
  }

  renderStatsTitle() {
    const {
      is_selecting_range,
      range_selected_dates,
      selected_date,
      start_date
    } = this.state;

    if (
      (is_selecting_range && range_selected_dates.length == 0) ||
      (!is_selecting_range && selected_date == null)
    ) {
      return (
        <Wrapper style={{ marginBottom: 15 }}>
          <Title>
            Mailers sent and scheduled for {moment(start_date).format("MMMM")}:
          </Title>
        </Wrapper>
      );
    } else {
      if (is_selecting_range && range_selected_dates.length == 2) {
        return (
          <Wrapper style={{ marginBottom: 15 }}>
            <Title>
              Mailers sent and scheduled between{" "}
              {moment(range_selected_dates[0]).format("MMM Do")}
              {" and "}
              {moment(range_selected_dates[1]).format("MMM Do")}:
            </Title>
          </Wrapper>
        );
      } else if (!is_selecting_range && selected_date) {
        return (
          <Wrapper style={{ marginBottom: 15 }}>
            <Title>
              Mailers sent and scheduled for{" "}
              {moment(selected_date).format("MMM Do")}:
            </Title>
          </Wrapper>
        );
      }
    }
  }

  renderStats() {
    if (!this.props.calendar_loading) {
      return (
        <Card>
          <CardBody>
            {this.renderStatsTitle()}
            <Row>
              <Wrapper style={{ flex: 1 }}>
                <InformationItem
                  item={this.state.total_mailers_sent}
                  label={"Total Mailers Sent:"}
                  format="number"
                />
              </Wrapper>
              <Wrapper style={{ flex: 1 }}>
                <InformationItem
                  item={this.state.total_mailers_in_queue}
                  label={"Total Mailers In Queue:"}
                  format="number"
                />
              </Wrapper>
            </Row>
            <Row>
              <Wrapper style={{ flex: 1 }}>
                <InformationItem
                  item={this.state.total_mailers_to_send}
                  label={"Total Mailers Scheduled:"}
                  format="number"
                />
              </Wrapper>
              <Wrapper style={{ flex: 1 }}>
                <InformationItem
                  item={renderPrice(this.state.total_dealcredit_to_spend)}
                  label={"Estimated Price For Scheduled Mailers:"}
                />
              </Wrapper>
            </Row>
          </CardBody>
        </Card>
      );
    }
  }

  renderLoading() {
    if (this.props.calendar_loading) {
      return (
        <Wrapper
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor:
              this.props.dark_mode === "dark_mode"
                ? "rgba(0,0,0,0.3)"
                : "rgba(255, 255, 255, 0.75)",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Row>
            <Spin size="small" />
            <Copy style={{ marginLeft: 5 }}>Loading Calendar...</Copy>
          </Row>
        </Wrapper>
      );
    }
  }

  renderToggle() {
    if (this.props.device == "desktop") {
      if (this.state.is_selecting_range) {
        if (
          (this.state.is_selecting_range &&
            this.state.range_selected_dates.length == 0) ||
          (!this.state.is_selecting_range && this.state.selected_date == null)
        ) {
          return (
            <Wrapper style={{ padding: 15 }}>
              <Copy>
                You are now viewing the current month's mailing information.
                Select a date range to break down information.
              </Copy>
            </Wrapper>
          );
        }

        return (
          <Wrapper style={{ padding: 15 }}>
            <Copy>
              You are now selecting a date range to view mailer information.
            </Copy>

            <Row>
              <PillButton
                onPress={() => {
                  this.setState({
                    is_selecting_range: false,
                    selected_date: null,
                    range_selected_dates: []
                  });
                }}
                style={{ marginLeft: 0 }}
              >
                Select a date
              </PillButton>
              <PillButton
                onPress={() => {
                  this.setState({
                    is_selecting_range: false,
                    selected_date: null,
                    range_selected_dates: [],
                    start_date: moment().startOf("month").format("YYYY-MM-DD"),
                    end_date: moment().endOf("month").format("YYYY-MM-DD")
                  });
                }}
                style={{ marginLeft: 0 }}
              >
                View current month
              </PillButton>
            </Row>
          </Wrapper>
        );
      } else {
        if (
          (this.state.is_selecting_range &&
            this.state.range_selected_dates.length == 0) ||
          (!this.state.is_selecting_range && this.state.selected_date == null)
        ) {
          return (
            <Wrapper style={{ padding: 15 }}>
              <Copy>
                You are now viewing the current month's mailing information.
                Select a date to break down information.
              </Copy>
            </Wrapper>
          );
        }
        return (
          <Wrapper style={{ padding: 15 }}>
            <Copy>
              You are now selecting an individual date to view mailer
              information.
            </Copy>

            <Row>
              <PillButton
                onPress={() => {
                  this.setState({
                    is_selecting_range: true,
                    selected_date: null,
                    range_selected_dates: []
                  });
                }}
                style={{ marginLeft: 0 }}
              >
                Select a range
              </PillButton>
              <PillButton
                onPress={() => {
                  this.setState({
                    is_selecting_range: false,
                    selected_date: null,
                    range_selected_dates: [],
                    start_date: moment().startOf("month").format("YYYY-MM-DD"),
                    end_date: moment().endOf("month").format("YYYY-MM-DD")
                  });
                }}
                style={{ marginLeft: 0 }}
              >
                View current month
              </PillButton>
            </Row>
          </Wrapper>
        );
      }
    } else {
      if (
        (this.state.is_selecting_range &&
          this.state.range_selected_dates.length == 0) ||
        (!this.state.is_selecting_range && this.state.selected_date == null)
      ) {
        return (
          <Wrapper style={{ padding: 15 }}>
            <Copy>
              You are now viewing the current month's mailing information.
              Select a date to break down information.
            </Copy>
          </Wrapper>
        );
      }

      return (
        <Wrapper style={{ padding: 15 }}>
          <Copy>
            You are now selecting an individual date to view mailer information.
          </Copy>

          <Row>
            <PillButton
              onPress={() => {
                this.setState({
                  is_selecting_range: false,
                  selected_date: null,
                  range_selected_dates: [],
                  start_date: moment().startOf("month").format("YYYY-MM-DD"),
                  end_date: moment().endOf("month").format("YYYY-MM-DD")
                });
              }}
              style={{ marginLeft: 0 }}
            >
              View current month
            </PillButton>
          </Row>
        </Wrapper>
      );
    }
  }
  updateEventListTab(event_list_tab) {
    this.setState({
      event_list_tab
    });

    this.getItems({
      type: event_list_tab,
      load_type: "refresh"
    });
  }
  renderMailersSentToggle() {
    if (this.state.total_mailers_sent > 0) {
      if (
        this.state.total_mailers_in_queue == 0 &&
        this.state.total_mailers_to_send == 0
      ) {
        return <Title>Mailers Sent:</Title>;
      }

      return (
        <EventListTab
          title={"Sent"}
          is_active={this.state.event_list_tab == "mailers_sent"}
          onPress={() => this.updateEventListTab("mailers_sent")}
          colors={this.props.colors}
        />
      );
    }
  }

  renderMailerQueueToggle() {
    if (this.state.total_mailers_in_queue > 0) {
      if (
        this.state.total_mailers_sent == 0 &&
        this.state.total_mailers_to_send == 0
      ) {
        return <Title>Mailers Queued:</Title>;
      }
      return (
        <EventListTab
          title={"Queued"}
          is_active={this.state.event_list_tab == "mailers_queued"}
          onPress={() => this.updateEventListTab("mailers_queued")}
          colors={this.props.colors}
        />
      );
    }
  }

  renderMailersToSendToggle() {
    if (this.state.total_mailers_to_send > 0) {
      if (
        this.state.total_mailers_sent == 0 &&
        this.state.total_mailers_in_queue == 0
      ) {
        return <Title>Mailers Scheduled:</Title>;
      }

      return (
        <EventListTab
          title={"Scheduled"}
          is_active={this.state.event_list_tab == "mailers_to_send"}
          onPress={() => this.updateEventListTab("mailers_to_send")}
          colors={this.props.colors}
        />
      );
    }
  }

  renderList() {
    if (
      this.state.total_mailers_sent > 0 ||
      this.state.total_mailers_in_queue > 0 ||
      this.state.total_mailers_to_send > 0
    ) {
      return (
        <Card>
          <Row style={{ padding: 15 }}>
            {this.renderMailersSentToggle()}
            {this.renderMailerQueueToggle()}
            {this.renderMailersToSendToggle()}
          </Row>

          <MailerList
            event_list_tab={this.state.event_list_tab}
            getItems={this.getItems}
            {...this.props}
          />
          <PropertyList
            event_list_tab={this.state.event_list_tab}
            getItems={this.getItems}
            {...this.props}
          />
        </Card>
      );
    }
  }

  render() {
    return (
      <Wrapper>
        <Card>
          <CardBody>
            <EventCalendar
              selected_date={this.state.selected_date}
              range_selected_dates={this.state.range_selected_dates}
              is_selecting_range={this.state.is_selecting_range}
              onDateChange={selected_item => {
                this.onDateChange(selected_item);
              }}
              onMonthChange={active_start_date => {
                this.onMonthChange(active_start_date);
              }}
              calendar_events={this.props.calendar_events}
              calendar_loading={this.props.calendar_loading}
              colors={this.props.colors}
            />
            {this.renderLoading()}
          </CardBody>
        </Card>
        {this.renderToggle()}
        {this.renderStats()}
        {this.renderList()}
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ auth, settings, native, activity }) => {
  const { token, user } = auth;
  const { colors, dark_mode } = settings;
  const { isMobile, device } = native;
  const {
    calendar_events,
    calendar_loading,
    calendar_error,

    activity_properties,
    activity_properties_loading,
    activity_properties_refreshing,
    activity_properties_loaded_all,
    activity_properties_begin,
    activity_properties_limit,
    activity_properties_type,

    mailers,
    mailers_loading,
    mailers_refreshing,
    mailers_loaded_all,
    mailers_begin,
    mailers_limit
  } = activity;

  return {
    token,
    user,
    isMobile,
    colors,
    dark_mode,
    device,
    calendar_events,
    calendar_loading,
    calendar_error,

    activity_properties,
    activity_properties_loading,
    activity_properties_refreshing,
    activity_properties_loaded_all,
    activity_properties_begin,
    activity_properties_limit,
    activity_properties_type,

    mailers,
    mailers_loading,
    mailers_refreshing,
    mailers_loaded_all,
    mailers_begin,
    mailers_limit
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  getCalendar,
  getMailers,
  getActivityProperties,
  selectActiveProperty
})(CalendarTab);
